import chain from '@/lib/axios-chain'

// 线索列表搜索字段
export const clueSearchKeys = () => chain.create('/inquiry/clue/getSearchkey', 'get')
// 线索列表数据获取
export const fetchClueDatas = () => chain.create('/inquiry/clue/index', 'get')
// 线索列表获取跟进字段记录
export const fetchFollowLog = () => chain.create('/inquiry/clue//getNextFollowInfo', 'get')
// 线索列表完成跟进
export const finishFollow = () => chain.create('/inquiry/clue/followupComplete', 'post')
// 线索列表标记失效
export const finishSign = () => chain.create('/inquiry/clue/upClueStatus', 'post')
// 获取线索字段
export const fetchClueFieldkeys = () => chain.create('/inquiry/clue/getClueField', 'get')
// 录入线索修改
export const editClueData = () => chain.create('/inquiry/clue/editClue', 'post')
// 录入线索添加提交
export const subClueData = () => chain.create('/inquiry/clue/addClue', 'post')
// 获取线索详情
export const fetchClueInfoData = () => chain.create('/inquiry/clue/getClueInfo', 'get')

// 验证字段重复性
export const checkClueFieldRepeat = () => chain.create('/inquiry/clue/fieldRepeat', 'get')
// 导出线索字段
export const exportClueFields = () => chain.create('/inquiry/clue/export', 'post')
// 导出线索字段
// export const checkClue = () => chain.create('/inquiry/clue/checkFollowup', 'post')
// 重新跟进
export const repeatFollowClue = () => chain.create('/inquiry/clue/againFloolw', 'post')
// 重新跟进
export const delClue = () => chain.create('/inquiry/clue/delClue', 'post')
// 获取导出配置字段
export const getExport = () => chain.create('/inquiry/clue/getquery', 'get')
// 编辑线索备注
export const eidtClueRemarks = () => chain.create('/inquiry/clue/editRemarks', 'post')

// 编辑线索备注
export const eidtClueFollowTime = () => chain.create('/inquiry/clue/editFollowDate', 'post')
// 获取线索离职数据
export const fetchClueQuitData = () => chain.create('/inquiry/clue/handoverClueList', 'get')
// 获取线索离职交接
export const clueQuithandover = () => chain.create('/inquiry/clue/handover', 'post')
// 线索列表获取权限
export const getCluePermission = () => chain.create('/inquiry/clue/cluePermission', 'get')
